// extracted by mini-css-extract-plugin
module.exports = {"errorPage":"ErrorPage_errorPage__icaiw"};